var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2649_13411)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39874 5.5089L5.88022 4.65391L9.99905 2.27554L15.5994 5.5089L11.4805 7.88727L13.4514 9.02599L14.9976 8.13291L17.5702 6.64762L19.5411 5.5089L17.5702 4.37018L14.9976 2.88489L10.001 0L5.00048 2.88679L2.42788 4.37208L0.457012 5.51081L2.42788 6.64953L5.00048 8.13482L10.001 11.0216L11.9718 9.88289L10.001 8.74417L4.40065 5.51081L4.39874 5.5089ZM18.0291 16.182L10.001 20.8169L1.97087 16.182L0 15.0433V17.3189L5.00048 20.2057L10.001 23.0924L15.0014 20.2057L20.0019 17.3189V11.0178L18.031 12.1565L10.0029 16.7914L1.97087 12.1584V10.4104L5.00048 12.1584L10.001 15.0452L15.0014 12.1584L20.0019 9.27164V6.9961L18.031 8.13482L10.0029 12.7697L1.97087 8.13291L0 6.99419V13.2952L5.00048 16.182L10.001 19.0688L15.0014 16.182L18.031 14.434V16.182H18.0291Z",
    fill: "#E3592E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2649_13411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 23.0944,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1d907ff4e09bf63d8c7150cf17a3b552.svg";
export { ForwardRef as ReactComponent };